import log from '@/services/log';
import { getDeviceTypeFromRoute, getReferralType } from '@/modules/helpers/functions';
import helperFunctions from '@/utils/helperFunctions';

export default function (to, store) {
  const payload = {
    product: helperFunctions.getProductFromRoute(to.path) || 'NA',
    apiKey: to.query.key,
    externalId: to.query.external_id,
    payload: {
      vin: to.query.vin,
      view: to.path,
      deviceType: getDeviceTypeFromRoute(to),
      referralType: getReferralType(to),
    },
  };

  store.dispatch('metrics/logModalImpression', payload).catch(error => {
    log('Error in logging impression', error);
  });
}
